/* eslint-disable camelcase */
import { useMutation } from '@apollo/client';
import * as Sentry from '@sentry/react';
import type { LearnerProfile_PatchPersonalInformationInput } from '__generated__/graphql-types';

import LearnerProfilePatchPersonalInformationMutation from 'bundles/account-profile/components/recruiting-profile-viewer/queries/LearnerProfilePatchPersonalInformationMutation.graphql';
import type {
  LearnerProfile_PatchPersonalInformationMutation as LearnerProfile_PatchPersonalInformationMutationData,
  LearnerProfile_PatchPersonalInformationMutationVariables,
} from 'bundles/account-profile/components/recruiting-profile-viewer/queries/__generated__/LearnerProfilePatchPersonalInformationMutation';

export const US_WORK_AUTHORIZATION_DEFAULT_VALUE = true;
export const US_REQUIRES_VISA_SPONSORSHIP_DEFAULT_VALUE = false;

export function useLearnerProfilePatchPersonalInformation() {
  const [updateLearnerProfilePatchPersonalInformationMutation, mutationState] = useMutation<
    LearnerProfile_PatchPersonalInformationMutationData,
    LearnerProfile_PatchPersonalInformationMutationVariables
  >(LearnerProfilePatchPersonalInformationMutation, { context: { clientName: 'gatewayGql' } });

  const updateLearnerProfilePatchPersonalInformation = async (input: LearnerProfile_PatchPersonalInformationInput) => {
    try {
      const result = await updateLearnerProfilePatchPersonalInformationMutation({
        variables: {
          input: {
            ...input,
          },
        },
        context: {
          clientName: 'gatewayGql',
        },
      });
      return result;
    } catch (error) {
      Sentry.captureException(error);
      return Promise.reject(error);
    }
  };

  return {
    updateLearnerProfilePatchPersonalInformation,
    learnerProfilePatchPersonalInformationLoading: mutationState.loading,
    error: mutationState.error,
  };
}
